import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import dateUser from './modules/dateUser/index.js';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    dateUser
  }
})
